export default __webpack_public_path__ + "static/media/thumbnail.c1090321.png";